// store.js
//COMMENT add comments
import { createPinia } from "pinia";

const pinia = createPinia();

export { pinia };
